import { render, staticRenderFns } from "./main.vue?vue&type=template&id=53f99160&scoped=true&"
import script from "./main.vue?vue&type=script&lang=ts&"
export * from "./main.vue?vue&type=script&lang=ts&"
import style0 from "../style/index.scss?vue&type=style&index=0&id=53f99160&scoped=true&lang=scss&"
import style1 from "../style/global.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f99160",
  null
  
)

export default component.exports